// Plain-language explanations shown by the info-tooltip icons on each KPI
// card and graph on the Device Dashboard. Kept in their own file for
// isolation from the component's logic. All values here are refreshed by a
// backend cron job every 15 minutes (not on every page load); most are
// all-time totals, except Active AIS140 Certified Devices, which only counts
// currently-valid (non-expired) certificates as of today.
export const deviceDashboardKpiInfo = {
  totalProduction:
    'Total number of device units that have ever been produced/registered in the system, counted across all time (not limited to a recent date range).\nUpdates automatically every 15 minutes.',
  dispatched:
    'Total number of devices that have been dispatched out for delivery/installation, counted across all time.\nUpdates automatically every 15 minutes.',
  aisCertified:
    'Total number of devices with a currently valid (not expired) AIS140 certificate, as of today - a device whose certificate has since expired is no longer counted here even if it passed certification in the past.\nUpdates automatically every 15 minutes.',
  installed:
    'Total number of devices that have an actual vehicle VIN assigned to them (i.e. physically installed in a vehicle), as opposed to a blank/placeholder VIN.\nUpdates automatically every 15 minutes.',
};

export const deviceDashboardGraphInfo = {
  deviceActivityOverview:
    'Groups every device by how long ago it last logged in to the server: Today, Five Days, Ten Days, Fifteen Days, More Than Fifteen, or Not Active.\nClick "Device Model Wise" to see this same breakdown split out per device model.\nUpdates automatically every 15 minutes.',
  firmwareWiseDetails:
    'Shows how many devices are currently running each Assigned Firmware (AF) version, based on the firmware version reported in each device\'s most recent login packet.\nClick "Device Model Wise" to see this same breakdown split out per device model.\nUpdates automatically every 15 minutes.',
  stateWiseDetails:
    'Shows how many devices are currently assigned to each RTO state.\nUpdates automatically every 15 minutes.',
};
